"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localPlayerReducer = exports.initialLocalPlayerState = void 0;
var state_1 = require("./state");
Object.defineProperty(exports, "initialLocalPlayerState", { enumerable: true, get: function () { return state_1.initialLocalPlayerState; } });
Object.defineProperty(exports, "localPlayerReducer", { enumerable: true, get: function () { return state_1.localPlayerReducer; } });
